import { ValidExtension } from "./ValidExtension";
import { IsJPEG } from "./IsJPEG";
import { Globals } from "../CoreApp/Globals";
import { enumUploadCode, kMaxFileSize, kMaxImageSize } from "../constants";
import { appstr } from "./appstr";

export function CheckFileValid(theFile) {
  let success = true;
  const i = document.getElementById("selectfile");
  const fileName = theFile.name;
  const { callback, excelonly: excelOnly, customtype: customType, restrict: restrictArray } = i;
  i.curfile = fileName;
  i.size = theFile.size;

  Globals._wsMgr.DoProgress(appstr("uploadingnow"));

  if (IsJPEG(fileName) && theFile.size > kMaxImageSize) {
    callback.UploadFailed(appstr("maximagesize"), fileName, enumUploadCode.maxsize);
    i.value = "";
    success = false;
    return success;
  }

  if (theFile.size > kMaxFileSize) {
    const message = `${appstr("maxfilesize")} ${kMaxFileSize / (1024 * 1024)}MB.`;
    callback.UploadFailed(message, fileName, enumUploadCode.maxsize);
    i.value = "";
    success = false;
    return success;
  }

  if (!ValidExtension(fileName, excelOnly, customType, restrictArray)) {
    let restrictLabel = "";
    if (restrictArray && restrictArray.length > 0) {
      const filteredArray = restrictArray.filter(item => !item.includes("oc5"));
      restrictLabel = `(${filteredArray.length > 1 ? filteredArray.join(", ").toUpperCase() : filteredArray.join("").toUpperCase()})`;
    }
    callback.UploadFailed(
      `${appstr("validfile")} ${restrictLabel}`,
      fileName,
      enumUploadCode.invalidtype
    );
    i.value = "";
    success = false;
    return success;
  }

  return success;
}
